import { Box, Button, Card, CardContent, CardMedia, Typography } from "@mui/material";
import FragmentFullContent from "../base/FragmentFullContent";
import { TopBar } from "../top/TopBar";
import { useNavigate } from "react-router";
import { getImagesUrl } from "../../redux/common";

export function PageNotFound() {

    const navigate = useNavigate();


    const item =
        {
            image: `${getImagesUrl()}/not-found.webp`,
            title: "Não encontrado",
            description: <Box>
                <Box>Pagina não encontrada.</Box>
                <Button onClick={() => navigate(-1)}>Voltar</Button>
                <Button onClick={() => navigate("/")}>Inicio</Button>
            </Box>
        };

    return <>
        <TopBar />
        <FragmentFullContent>
            <Card sx={{ display: "flex", m: 1 }} elevation={3}>
            <CardMedia component="img" sx={{ width: { xs: 80, sm: 160 } }} image={item.image} />
            <CardContent sx={{ flex: 1 }}>
                <Typography component="h2" variant="h5">
                    {item.title}
                </Typography>
                <Typography variant="subtitle2">
                    {item.description}
                </Typography>
            </CardContent>
            </Card>
        </FragmentFullContent>
    </>;
}